import React from 'react';
import {
  ComponentsAllocationModal,
  PauseSubscriptionModal,
  ResumeSubscriptionModal,
  CancelSubscriptionModal,
  ReactivateSubscriptionModal,
  UndoCancelationModal,
  ChangeSubscriptionPlanModal,
  ThreeDsConfirmationModal,
  AddCouponModal,
} from '../../modals';

export const ModalsContainer = () => {
  return (
    <>
      <AddCouponModal />
      <ReactivateSubscriptionModal />
      <ComponentsAllocationModal />
      <ResumeSubscriptionModal />
      <PauseSubscriptionModal />
      <CancelSubscriptionModal />
      <UndoCancelationModal />
      <ChangeSubscriptionPlanModal />
      <ThreeDsConfirmationModal />
    </>
  );
};
